export interface Filter {
  /**
   * If provided, filtering should be constrained to this scope (or object
   * property in pracatice)
   */
  scope?: string;

  /** The actual string to filter with. */
  term: string;
}

export const SCOPE_TERM_DELIMITER = ' : ';

export const serializeFilter = ({ scope, term }: Filter) =>
  scope ? `${scope}${SCOPE_TERM_DELIMITER}${term}` : term;

export const serializeFilters = (filters: Filter[]) =>
  filters.map(serializeFilter);

export const deserializeFilter = (str: string): Filter => {
  const [scopeOrTerm, term] = str.split(SCOPE_TERM_DELIMITER);

  if (scopeOrTerm && term) {
    return {
      scope: scopeOrTerm,
      term: term.trim(),
    };
  }

  return {
    term: scopeOrTerm.trim(),
  };
};
